<template lang="pug">
v-expansion-panels.gap-20(
  :value="openedPanels"
  accordion
  multiple
)

  dv-alert.full-width(
    color="ui-warning"
    v-if="isPfdoCreated && !hideDisabled"
  ): .ui-neutral--text Некоторые поля недоступны для редактирования, потому что они заполняются на ПФДО

  panel-region(
    v-if="!hideDisabled || !isDisabled.region"
    v-model="form.region"
    :disabled="isDisabled.region"
    @click:select="onSelect(0)"
  )

  panel-municipality(
    v-if="!hideDisabled || !isDisabled.municipality"
    v-model="form.municipality"
    :region-id="regionId"
    :disabled="isDisabled.municipality"
    @click:select="onSelect(1)"
  )

  panel-text-input(
    v-if="!hideDisabled || !isDisabled.contactPhone"
    v-model="form.contactPhone"
    title="Телефон"
    no-reset
    :component="constants.PANEL_TEXT_INPUT_COMPONENT_KEY.phone"
    :disabled="isDisabled.contactPhone"
    @click:select="onSelect(2)"
  )

  panel-text-input(
    v-if="!hideDisabled || !isDisabled.contactFullName"
    v-model="form.contactFullName"
    title="Ответственное лицо"
    no-reset
    :component="constants.PANEL_TEXT_INPUT_COMPONENT_KEY.textInput"
    :disabled="isDisabled.contactFullName"
    @click:select="onSelect(3)"
  )

  panel-text-input(
    v-if="!hideDisabled || !isDisabled.headFullName"
    v-model="form.headFullName"
    title="ФИО руководителя"
    no-reset
    :component="constants.PANEL_TEXT_INPUT_COMPONENT_KEY.textInput"
    :disabled="isDisabled.headFullName"
    @click:select="onSelect(4)"
  )

  panel-select(
    v-if="!hideDisabled || !isDisabled.ground"
    v-model="form.ground"
    title="Местность"
    :items="groundItems"
    :disabled="isDisabled.ground"
    @click:select="onSelect(5)"
  )

  panel-address(
    v-if="!hideDisabled || !isDisabled.legalAddress"
    v-model="form.legalAddress"
    title="Юридический адрес"
    :disabled="isDisabled.legalAddress"
    @click:select="onSelect(6)"
  )

  panel-address(
    v-if="!hideDisabled || !isDisabled.factAddress"
    v-model="form.factAddress"
    title="Фактический адрес"
    :disabled="isDisabled.factAddress"
    @click:select="onSelect(7)"
  )

  panel-text-input(
    v-if="!hideDisabled || !isDisabled.inn"
    v-model="form.inn"
    title="ИНН"
    :component="constants.PANEL_TEXT_INPUT_COMPONENT_KEY.inn"
    :disabled="isDisabled.inn"
    @data-by-inn="onInnAutofill"
    @click:select="onSelect(8)"
  )

  panel-text-input(
    v-if="!hideDisabled || !isDisabled.kpp"
    v-model="form.kpp"
    title="КПП"
    :disabled="isDisabled.kpp"
    no-reset
    :maxlength="9"
    @click:select="onSelect(9)"
  )

  panel-select(
    v-if="!hideDisabled || !isDisabled.eduType"
    v-model="form.eduType"
    title="Тип образовательной организации"
    :items="eduTypeItems"
    :disabled="isDisabled.eduType"
    @click:select="onSelect(10)"
  )
  slot(name="save" v-bind="{ loading: isLoading, hasChanges, update }")
    app-button(
      :loading="isLoading"
      :disabled="!hasChanges"
      rounded
      @click="update"
    ) Сохранить
</template>

<script>
import PanelRegion from '@/modules/UserProfile/components/Profile/Sections/Panels/PanelRegion.vue';
import PanelMunicipality from '@/modules/UserProfile/components/Profile/Sections/Panels/PanelMunicipality.vue';
import PanelTextInput from '@/modules/UserProfile/components/Profile/Sections/Panels/PanelTextInput.vue';
import PanelAddress from '@/modules/UserProfile/components/Profile/Sections/Panels/PanelAddress.vue';
import { PANEL_TEXT_INPUT_COMPONENT_KEY } from '@/modules/UserProfile/components/Profile/Sections/constants';
import PanelSelect from '../../../../Sections/Panels/PanelSelect.vue';
import { GROUND_DATA, EDU_TYPE_DATA } from '@/modules/UserProfile/constants';
import DvAlert from '@/packages/ui/components/alerts/DvAlert.vue';

const FIELDS_TO_FORM = {
  inn: 'inn',
  kpp: 'kpp',
  region: 'region',
  municipality: 'municipality',
  head_full_name: 'headFullName',
  contact_full_name: 'contactFullName',
  contact_phone: 'contactPhone',
  fact_address: 'factAddress',
  legal_address: 'legalAddress',
  ground: 'ground',
  edu_type: 'eduType',
};

const BASE_DISABLED_ITEMS = {
  region: false,
  municipality: false,
  contactPhone: false,
  contactFullName: false,
  headFullName: false,
  ground: false,
  legalAddress: false,
  factAddress: false,
  inn: false,
  kpp: false,
  eduType: false,
};

export default {
  name: 'MainEditForm',
  components: {
    PanelRegion,
    PanelMunicipality,
    PanelTextInput,
    PanelAddress,
    PanelSelect,
    DvAlert,
  },
  props: {
    activeFields: {
      type: Array,
      default: () => [],
    },
    hideDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openedPanels: [],
      isLoading: false,
      form: {
        region: this.$user.profile.region,
        municipality: this.$user.profile.municipality,
        contactPhone: this.$user.profile.contact_phone,
        contactFullName: this.$user.profile.contact_full_name,
        headFullName: this.$user.profile.head_full_name,
        ground: this.$user.profile.ground,
        legalAddress: this.$user.profile.legal_address,
        factAddress: this.$user.profile.fact_address,
        inn: this.$user.profile.inn,
        eduType: this.$user.profile.edu_type,
        kpp: this.$user.profile.kpp,
      },
      formJSON: '',
      groundItems: Object.values(GROUND_DATA),
      eduTypeItems: Object.values(EDU_TYPE_DATA),
    };
  },
  computed: {
    constants() {
      return {
        PANEL_TEXT_INPUT_COMPONENT_KEY,
      };
    },
    serializableFormData() {
      // const initial = JSON.parse(this.formJSON);
      const newForm = this.form;
      // Object.entries(this.form).reduce((acc, [key, value]) => {
      //   if (
      //     !value
      //     || (JSON.stringify(initial[key]) === JSON.stringify(value))
      //   ) {
      //     return acc;
      //   }
      //   acc[key] = value;
      //   return acc;
      // }, {});
      const data = {
        region_id: newForm.region?.id,
        municipality_id: newForm.municipality?.id,
        contact_phone: newForm.contactPhone,
        contact_full_name: newForm.contactFullName,
        head_full_name: newForm.headFullName,
        legal_address: newForm.legalAddress,
        fact_address: newForm.factAddress,
        inn: newForm.inn,
        ground: newForm.ground,
        edu_type: newForm.eduType,
        kpp: newForm.kpp,
      };

      return Object.entries(data).reduce((acc, [key, value]) => {
        if (!value) { // && !['contact_full_name', 'head_full_name', 'contact_phone'].includes(key)
          return acc;
        }

        acc[key] = value;

        return acc;
      }, {});
    },
    hasChanges() {
      return [this.hasProfileChanges].some(Boolean);
    },
    hasProfileChanges() {
      return JSON.stringify(this.form) !== this.formJSON;
    },
    regionId() {
      return this.form.region?.id;
    },
    isPfdoCreated() {
      return this.$user.isPfdoCreated;
    },
    isDisabled() {
      const {
        isPfdoCreated,
        // formJSON,
        activeFields,
      } = this;
      // const form = JSON.parse(formJSON);
      return {
        ...BASE_DISABLED_ITEMS,
        ...isPfdoCreated ? {
          ...Object.fromEntries(
            Object.keys(BASE_DISABLED_ITEMS)
              .map((key) => ([key, false])), // !!form[key]
          ),
          // kpp: true,
          inn: true,
        } : {},
        ...activeFields?.length ? {
          ...Object.fromEntries(
            Object.keys(BASE_DISABLED_ITEMS)
              .map((key) => ([key, true])),
          ),
          ...Object.fromEntries(
            activeFields.map((field) => [FIELDS_TO_FORM[field], false]),
          ),
        } : {},
      };
    },
  },
  watch: {
    regionId() {
      this.form.municipality = null;
    },
  },
  created() {
    this.formJSON = JSON.stringify(this.form);
  },
  methods: {
    onSelect(index) {
      this.openedPanels = this.openedPanels.filter((value) => value !== index);
    },
    onInnAutofill(data) {
      const {
        head_full_name: headFullName,
        short_name: shortName,
        full_name: fullName,
        legal_address: legalAddress,
        fact_address: factAddress,
      } = data;

      this.form = {
        ...this.form,
        headFullName,
        shortName,
        fullName,
        legalAddress,
        factAddress,
      };
    },
    update() {
      if (!this.hasChanges) {
        return;
      }

      this.isLoading = true;
      const promises = [];

      if (this.hasProfileChanges) {
        promises.push(this.updateProfile());
      }

      Promise.all(promises)
        .then((responses) => {
          if (!responses.some((i) => i?.error)) {
            this.openedPanels = [];
            this.$toast.success('Информация обновлена');
            this.$emit('saved');
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async updateProfile() {
      const payload = {
        ...this.serializableFormData,
      };
      const args = [this.$user.profile.id];

      const { response, error } = await this.$rApi.user.updateOrganization({ args, data: payload });
      if (!error) {
        this.$user.patchProfile(this.form);
        this.formJSON = JSON.stringify(this.form);
      }
      return { response, error };
    },
  },
};
</script>
